
/**
 * Centralized storage for API keys
 */

/**
 * SECURITY NOTICE: API keys have been moved to secure environment variables
 * This file is deprecated and maintained only for backward compatibility
 * All new code should use the secure API client instead
 */
// DEPRECATED: Client-side API key storage removed for security
export const API_KEYS = {
  // All API keys have been moved to secure Supabase environment variables
  // Client-side access has been completely removed for security
  openai: {
    deepAnalysis: '',
    recommended: '',
    sitemap: '',
    faqSerp: ''
  }
};

/**
 * Get the OpenAI API key for a specific feature
 * @deprecated Use secure API client instead - this returns empty for security
 */
export function getOpenAIKey(feature: 'deepAnalysis' | 'recommended' | 'sitemap' | 'faqSerp'): string {
  console.warn(`⚠️ SECURITY WARNING: getOpenAIKey() is deprecated. Use secure API client for feature: ${feature}`);
  return '';
}

/**
 * Update an OpenAI API key
 * @deprecated API keys are now managed securely in Supabase environment variables
 */
export function updateOpenAIKey(feature: 'deepAnalysis' | 'recommended' | 'sitemap' | 'faqSerp', key: string): void {
  console.warn(`⚠️ SECURITY WARNING: updateOpenAIKey() is deprecated. API keys are now managed securely.`);
  // No-op for security
}
